import React from 'react';
import { ConfirmProvider } from 'material-ui-confirm';
import { Provider } from 'react-redux';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import UpdatePrompt from '../UpdatePrompt/UpdatePrompt';
import { useServiceWorkerUpdate } from '../../hooks/useServiceWorkerUpdate';

interface AppWrapperProps {
  store: any;
  children: React.ReactNode;
}

const AppWrapper: React.FC<AppWrapperProps> = ({ store, children }) => {
  const { showUpdatePrompt, acceptUpdate, dismissUpdate } = useServiceWorkerUpdate();

  return (
    <ConfirmProvider>
      <Provider store={store}>
        <BrowserRouter>
          {children}
          <UpdatePrompt
            show={showUpdatePrompt}
            onUpdate={acceptUpdate}
            onDismiss={dismissUpdate}
          />
        </BrowserRouter>
      </Provider>
    </ConfirmProvider>
  );
};

export default AppWrapper;
